//#region src/loyalty_in_menu_mode.ts
let LoyaltyInMenuMode = /* @__PURE__ */ function(LoyaltyInMenuMode) {
	LoyaltyInMenuMode["Off"] = "off";
	LoyaltyInMenuMode["ShowLogInButton"] = "show-log-in-button";
	LoyaltyInMenuMode["PromptToLogInAtTheBeginning"] = "prompt-to-log-in-at-the-beginning";
	LoyaltyInMenuMode["PromptToLogInAtTheBeginningWithLoginOptions"] = "prompt-to-log-in-at-the-beginning-with-login-options";
	LoyaltyInMenuMode["PromptToLogInAtTheBeginningWithLoginOptionsPopup"] = "prompt-to-log-in-at-the-beginning-with-login-options-popup";
	return LoyaltyInMenuMode;
}({});
//#endregion
export { LoyaltyInMenuMode };

//# sourceMappingURL=loyalty_in_menu_mode.js.map